// extracted by mini-css-extract-plugin
export default {"QuestionTooltip":"QuestionTooltip_QuestionTooltip__kWE+y","question":"QuestionTooltip_question__AoE5I","tooltip":"QuestionTooltip_tooltip__5D9rH"};